import React from "react";
import { useEffect, useRef } from "react";
import { haversine_distance, isTouch } from "../helpers/Helpers";
import { LocStrings } from "../const/LocStrings";

function CenterInfoCell({ centerData, userLocation, idx, activeCenterID, setActiveCenterID, parentHolderRef }) {
  const selfRef = useRef();

  const handleMouseEnter = () => {
    if (!isTouch()) {
      setActiveCenterID(centerData.id);
    }
  };
  const handleMouseLeave = () => {
    if (!isTouch()) {
      setActiveCenterID(0);
    }
  };

  const userDistanceInfo = () => {
    // console.log("DIST CENTER:", centerData);
    // console.log("DIST LOCATI:", userLocation);
    if (userLocation != null) {
      const loc1 = {
        lat: userLocation.lat,
        lng: userLocation.lng,
      };
      const loc2 = {
        lat: centerData.location.latitude,
        lng: centerData.location.longitude,
      };
      const dist = haversine_distance(loc1, loc2);
      return <div className="c-locator__distance">{dist.toFixed(1)} miles</div>;
    } else {
      // console.log("DIST - bailing");
      return null;
    }
  };

  const handleClick = (e, oldActiveID) => {
    console.log("Click!");
    // if (centerData.is_active!==true) {
    // 		e.preventDefault();
    // 		return; //doing nothing for coming soon centers.
    // }

    if (isTouch()) {
      console.log("IS touch:", oldActiveID, activeCenterID, centerData.id);
      if (oldActiveID !== centerData.id) {
        //for touch devices, first touch doesn't result in link jump
        e.preventDefault();
      }
      setActiveCenterID(centerData.id);
    }
  };

  const localizedCenterURL = () => {
    const lang = document.location.pathname.indexOf("/es") !== -1 ? "es" : "en";
    if (lang === "es") {
      return centerData.permalink.replace("/centers/", "/es/centers/");
    } else {
      return centerData.permalink;
    }
  };

  const scrollParentToChild = (parent, child) => {
    if (activeCenterID === 0) return;

    console.log("Scroll parent to child:", parent, child, activeCenterID);

    // Where is the parent on page
    var parentRect = parent.getBoundingClientRect();
    // What can you see?
    var parentViewableArea = {
      height: parent.clientHeight,
      width: parent.clientWidth,
    };

    // Where is the child
    var childRect = child.getBoundingClientRect();
    // Is the child viewable?
    var isViewable = childRect.top >= parentRect.top && childRect.top <= parentRect.top + parentViewableArea.height;

    // if you can't see the child try to scroll parent
    if (!isViewable) {
      // scroll by offset relative to parent
      parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top;
    }
  };

  useEffect(() => {
    //selfRef.current.scrollIntoView({block: "start", inline: "nearest", behavior: "smooth"});
    if (activeCenterID === centerData.id) {
      scrollParentToChild(parentHolderRef.current, selfRef.current);
    }
  }, [activeCenterID, parentHolderRef, scrollParentToChild]);

  const wrapperCell = (children) => {
    if (centerData.is_active === true) {
      return (
        <a
          ref={selfRef}
          href={localizedCenterURL()}
          className={"c-locator__cell " + (activeCenterID === centerData.id ? "is-active" : "")}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => handleClick(e, activeCenterID)}
        >
          {children}
        </a>
      );
    } else {
      return (
        <div
          ref={selfRef}
          className={"c-locator__cell " + (activeCenterID === centerData.id ? "is-active" : "")}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => handleClick(e, activeCenterID)}
        >
          {children}
        </div>
      );
    }
  };

  return wrapperCell(
    <>
      <div className="c-locator__cell-info">
        {!centerData.is_active && <div className="c-locator__cell-note">{LocStrings.comingSoon}</div>}
        <div className="c-locator__cell-head">
          <span>{idx + 1}.</span> {centerData.name}
        </div>

        {centerData.should_show_address === true && (
          <div className="c-locator__cell-address">
            <div>{centerData.address.address_1}</div>
            {centerData.address.address_2.length > 0 && <div>{centerData.address.address_2}</div>}
            <div>
              {centerData.address.city}, {centerData.address.state} {centerData.address.zipcode}
            </div>
          </div>
        )}

        {centerData.location_details && (
          <div className="c-locator__cell-location-details">{centerData.location_details}</div>
        )}

        {activeCenterID === centerData.id && centerData.is_active === true && isTouch() && (
          <div className="c-locator__cell-tapagain link--arrow">{LocStrings.tapAgainForDetails}</div>
        )}
      </div>

      <div className="c-locator__cell-distance">{userDistanceInfo()}</div>
    </>
  );
}

export default CenterInfoCell;
